import React from 'react';
import { useComplianceBreach } from '../hooks/use-compliance-breach.js';
import ComplianceBreachPageView from './compliance-breach-page-view.jsx';

function ComplianceBreachPageContainer() {
  const state = useComplianceBreach();
  return <ComplianceBreachPageView {...state} />;
}

export default ComplianceBreachPageContainer;
